var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.active)?_c('div',{staticClass:"h-100 w-100 z-1210 top-0 start-0 transition position-fixed flex-center"},[(_vm.isMobile)?_c('div',{staticClass:"spinner-border text-primary"}):_vm._e()]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }